import { DollarSign } from "lucide-react";

export const PriceRating = ({ price, size = 14 }) => {
  return (
    <div className="flex items-center">
      {[1, 2, 3, 4, 5].map((i) => (
        <DollarSign
          key={i}
          size={size}
          className={i <= price ? "text-emerald-500" : "text-zinc-700"}
        />
      ))}
    </div>
  );
};

export default PriceRating;
